import { render, staticRenderFns } from "./AreaRelevanteInteresseEcologicoArie.vue?vue&type=template&id=6074dd00&lang=pug"
import script from "./AreaRelevanteInteresseEcologicoArie.vue?vue&type=script&lang=js"
export * from "./AreaRelevanteInteresseEcologicoArie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports